"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestAvailabilitiesWorkspace = void 0;
const apollo_1 = require("@app/util/apollo");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const AVAILABILITIES_WORKSPACE_QUERY = (0, graphql_tag_1.default) `
  query AvailabilitiesWorkspaceQuery(
    $workspace: ID!
    $period: PeriodInput!
    $users: [ID!]
  ) {
    workspace(id: $workspace) {
      availabilities(period: $period, users: $users) {
        id
        userId
        workspaceId
        period {
          end
          start
        }
        available
        note
        recurrence {
          value
          until
          type
          id
        }
        created
      }
    }
  }
`;
const requestAvailabilitiesWorkspace = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(AVAILABILITIES_WORKSPACE_QUERY, {
        variables,
    });
    if (errors) {
        return errors[0];
    }
    return data?.workspace.availabilities;
};
exports.requestAvailabilitiesWorkspace = requestAvailabilitiesWorkspace;
// async function requestAvailabilitiesWorkspace(variables, token) {
//   const response = await fetchRequest({
//     query: AVAILABILITIES_WORKSPACE_QUERY,
//     variables,
//     token,
//   })
//   if (!response) return errUtil.noResponse()
//   const { errors, data } = response
//   if (errors) {
//     return errUtil.apiError('availabilities', errors)
//   }
//   return data.workspace.availabilities
// }
exports.default = exports.requestAvailabilitiesWorkspace;
